import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { MatDialog } from '@angular/material';
import { TranslateContext } from '@shared/pipes/translate.pipe';
@Component({
    selector: 'amd-generic-view-attachment-upload',
    templateUrl: './generic-view-attachment-upload.component.html',
    styleUrls: ['./generic-view-attachment-upload.component.scss']
})
export class GenericViewAttachmentUploadComponent implements OnInit {
    @Output() uploadFileEventEmitter: EventEmitter<void> = new EventEmitter<void>();
	translateContext = TranslateContext;
    @Input() isClaimsAuthority: boolean = false;

    constructor(
        public _dialog: MatDialog,
    ) { }

    ngOnInit() {
    }

    addAttachment() {
        this.uploadFileEventEmitter.emit();
    }
}
